import { type ReactNode } from 'react';

import { CopyToClipboardButton } from '../../Clipboard/index.js';

interface MarkdownCopyToClipboardProps {
  content: ReactNode;
  mode: 'Visible' | 'Hidden';
}

export function MarkdownCopyToClipboard(props: MarkdownCopyToClipboardProps) {
  const { content, mode } = props;
  if (mode === 'Hidden' || typeof content !== 'string') {
    return null;
  }

  return <CopyToClipboardButton content={content} />;
}
